import { createContext, useContext, useEffect, useMemo, useState } from "react";

const ColorSchemeContext = createContext(null);
const STORAGE_KEY = "beekeeper.color_scheme";

function getInitialScheme() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function ColorSchemeProvider({ children }) {
  const [scheme, setScheme] = useState(getInitialScheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", scheme);
    localStorage.setItem(STORAGE_KEY, scheme);
  }, [scheme]);

  const value = useMemo(
    () => ({
      scheme,
      isDark: scheme === "dark",
      toggle: () => setScheme((s) => (s === "dark" ? "light" : "dark")),
      setScheme,
    }),
    [scheme]
  );

  return <ColorSchemeContext.Provider value={value}>{children}</ColorSchemeContext.Provider>;
}

export function useColorScheme() {
  const ctx = useContext(ColorSchemeContext);
  if (!ctx) throw new Error("useColorScheme must be used within ColorSchemeProvider");
  return ctx;
}
